import { PageId } from '@blcloud/bl-ng-share-module';

/** 画面ID */
export const PAGE_ID = PageId.ReceptionCaseList;

/** 画面タイトル */
export const PAGE_TITLE = '受付一覧';

/**
 * 使用する商品サービスコード定義
 */
export const ItemServiceNumber = {
  /** 鈑金・塗装 */
  SheetMetal: 900101,
  /** 軽鈑金 */
  LightSheetMetal: 900102,
};

/**
 * メッセージ
 */
export const MESSAGE = {
  /** 利用権限無し */
  NO_PERMISSION_TO_USE: '利用権限をご確認ください。',
  /** 顧客または車両が未登録 */
  UNREGISTERED_CUSTOMER_OR_VEHICLE: '顧客または車両が未登録のため利用できません。',
};



// WEBPACK FOOTER //
// ./src/app/page/recept-list-page/recept-list-page.define.ts